import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import CheckInError from '../CheckInError';
import EarlyCheckIn from '../EarlyCheckIn';
import ConfirmIdentity from '../ConfirmIdentity';
import CustomerIdentification from '../CustomerIdentification';
import Payment from '../Payment';
import CreditCard from '../CreditCard';
import PrintKey from '../PrintKey';

const CheckInContent = ({earlyCheckInBookings, name, status, setStatus }) => {

  return (
    <Switch>
      <Route
        path={'/group-check-in/early-check-in/:groupId'}
        render={() =>
          <EarlyCheckIn
            earlyCheckInBookings={earlyCheckInBookings}
            status={status}
          />
        } 
      />
      <Route
        path={'/group-check-in/confirm-identity/:groupId'}
        render={() => <ConfirmIdentity status={status}/>} 
      />
      <Route
        path={'/group-check-in/customer-identification/:groupId'}
        render={() => <CustomerIdentification  status={status}/>} 
      />
      <Route
        path={'/group-check-in/payment/:groupId'}
        render={() => <Payment status={status} setStatus={setStatus}/>} 
      />
      <Route
        path={'/group-check-in/credit-card/:groupId'}
        render={() => <CreditCard status={status}/>} 
      />
      <Route
        path={'/group-check-in/print-key/:groupId'}
        render={() => <PrintKey name={name} status={status}/>} 
      />
      <Route
        path={'/group-check-in/:groupId'}
        render={() => <CheckInError />} 
      />
      <Redirect to={'/group-check-in/:groupId'} />
    </Switch>
  );
};

export default CheckInContent;